import useShared from "../../../../../shared/_common/_shared";

export default function FundaEmptyData(props) {
    const {title} = props;
    const {IconCommon} = useShared();

    return (
        <div className={"w-full flex justify-center"}>
            <IconCommon
                isAlwaysInActive
                iconName={"cm-empty-regular"}
                className={"empty-data"}
                title={title || "noData"}
            />
        </div>
    );
}
